(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-cart-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Cart banner now only carries the trust badges (progress bar removed
    // 2026-08-10). We still refresh the /cart page footer's estimated total
    // when the cart changes externally (mini-cart add, etc.) so numbers stay
    // in sync without a full page reload.
    function refreshFooter() {
      var footer = document.getElementById('main-cart-footer');
      if (!footer) return;
      var sectionId = footer.getAttribute('data-id');
      if (!sectionId) return;
      fetch('/cart?section_id=' + encodeURIComponent(sectionId))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var src = doc.querySelector('.js-contents');
          var dst = footer.querySelector('.js-contents');
          if (src && dst) dst.innerHTML = src.innerHTML;
        })
        .catch(function () {});
    }
    if (typeof window.subscribe === 'function') {
      window.subscribe('cart-update', function (e) {
        if (e && e.source === 'cart-items') return; // Dawn's own handler already refreshes
        refreshFooter();
      });
    }
    document.addEventListener('kasha:cart-changed', function () { refreshFooter(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var burger = document.querySelector('[data-kasha-burger]');
    var drawer = document.querySelector('[data-kasha-drawer]');
    if (!burger || !drawer) return;
    burger.addEventListener('click', function () {
      var open = drawer.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      burger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      document.body.style.overflow = open ? 'hidden' : '';
    });
    drawer.addEventListener('click', function (e) {
      if (e.target.tagName === 'A') {
        drawer.classList.remove('is-open');
        burger.setAttribute('aria-expanded', 'false');
        burger.setAttribute('aria-label', 'Open menu');
        document.body.style.overflow = '';
      }
    });
  })();

  // Compact search dropdown anchored beneath the search icon.
  // Open: click or hover on the icon. Close: click outside, Escape, or hover out.
  (function () {
    var wrap = document.querySelector('[data-kasha-search-wrap]');
    var toggle = document.querySelector('[data-kasha-search-toggle]');
    var overlay = document.querySelector('[data-kasha-search-overlay]');
    if (!wrap || !toggle || !overlay) return;
    var input = overlay.querySelector('[data-kasha-search-input]');
    var hasHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var closeTimer = null;

    function openPop(autofocus) {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      if (!overlay.hidden) return;
      overlay.hidden = false;
      overlay.setAttribute('aria-hidden', 'false');
      if (autofocus) {
        requestAnimationFrame(function () { if (input) input.focus(); });
      }
    }
    function closePop() {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      if (overlay.hidden) return;
      overlay.hidden = true;
      overlay.setAttribute('aria-hidden', 'true');
      if (input) input.value = '';
    }
    function scheduleClose() {
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(closePop, 220);
    }
    function cancelClose() {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    }

    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      if (overlay.hidden) openPop(true); else closePop();
    });
    if (hasHover) {
      toggle.addEventListener('mouseenter', function () { openPop(false); });
      toggle.addEventListener('mouseleave', scheduleClose);
      overlay.addEventListener('mouseenter', cancelClose);
      overlay.addEventListener('mouseleave', scheduleClose);
    }
    document.addEventListener('click', function (e) {
      if (overlay.hidden) return;
      if (!wrap.contains(e.target)) closePop();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !overlay.hidden) closePop();
    });
  })();

  // Hover-to-open for nav dropdowns (Help & FAQ etc.) on devices with a real
  // pointer. Touch devices fall through to the default <details> click toggle.
  (function () {
    if (!window.matchMedia || !window.matchMedia('(hover: hover)').matches) return;
    var dropdowns = document.querySelectorAll('.kasha-header__dropdown-wrap, .kasha-header__mega-wrap');
    dropdowns.forEach(function (d) {
      var closeTimer = null;
      function open() {
        if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
        d.open = true;
      }
      function scheduleClose() {
        if (closeTimer) clearTimeout(closeTimer);
        closeTimer = setTimeout(function () { d.open = false; }, 120);
      }
      d.addEventListener('mouseenter', open);
      d.addEventListener('mouseleave', scheduleClose);
      d.addEventListener('focusin', open);
      d.addEventListener('focusout', function (e) {
        if (!d.contains(e.relatedTarget)) scheduleClose();
      });
    });
  })();

  // Prefetch /cart the first time the user hovers the bag link; makes the
  // cart page open instantly.
  (function () {
    var cartLink = document.querySelector('[data-kasha-cart-link]');
    if (!cartLink) return;
    var fired = false;
    function warm() {
      if (fired) return; fired = true;
      var l = document.createElement('link');
      l.rel = 'prefetch'; l.href = cartLink.getAttribute('href') || '/cart'; l.as = 'document';
      document.head.appendChild(l);
    }
    cartLink.addEventListener('mouseenter', warm, { once: true });
    cartLink.addEventListener('focus', warm, { once: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var setHead = function () {
      var h = document.querySelector('.shopify-section-group-header-group')
           || document.querySelector('header');
      document.documentElement.style.setProperty('--head', ((h && h.offsetHeight) || 0) + 'px');
    };
    setHead();
    window.addEventListener('resize', setHead);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-pdp-buybox"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sticky = document.querySelector('[data-pdp-sticky]');
    var buybox = document.getElementById('kasha-pdp-buybox');
    if (!sticky || !buybox) return;
    function onScroll() {
      var r = buybox.getBoundingClientRect();
      if (r.bottom < 80) {
        sticky.classList.add('is-visible');
      } else {
        sticky.classList.remove('is-visible');
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();

  (function () {
    var box = document.getElementById('kasha-pdp-buybox');
    if (!box) return;
    var hero = box.querySelector('.kasha-pdp-hero-img');
    var thumbs = box.querySelectorAll('[data-pdp-thumb]');
    if (!hero || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (!full) return;
        hero.removeAttribute('srcset');
        hero.removeAttribute('sizes');
        hero.src = full;
        var alt = thumb.getAttribute('data-alt');
        if (alt) hero.alt = alt;
        thumbs.forEach(function (t) { t.classList.remove('is-on'); });
        thumb.classList.add('is-on');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-quiz"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var quiz = document.querySelector('.kasha-quiz');
    if (!quiz) return;
    var steps = quiz.querySelectorAll('[data-quiz-step]');
    var gate = quiz.querySelector('[data-quiz-gate]');
    var result = quiz.querySelector('[data-quiz-result]');
    var bar = quiz.querySelector('[data-quiz-progress]');
    var total = steps.length + 1;
    var idx = 0;
    var answers = {};

    function setProgress(n) { bar.style.width = (n / total) * 100 + '%'; }

    function show(el) {
      steps.forEach(function (s) { s.hidden = true; });
      gate.hidden = true;
      result.hidden = true;
      el.hidden = false;
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    function refreshNext(stepEl) {
      var next = stepEl.querySelector('[data-quiz-next]');
      if (!next) return;
      if (next.hasAttribute('data-optional')) { next.disabled = false; return; }
      var q = stepEl.querySelector('[data-q]');
      var key = q ? q.getAttribute('data-q') : null;
      var has = key && answers[key] && (Array.isArray(answers[key]) ? answers[key].length : true);
      next.disabled = !has;
    }

    quiz.querySelectorAll('.kasha-quiz__opt').forEach(function (opt) {
      opt.addEventListener('click', function () {
        var key = opt.getAttribute('data-q');
        var val = opt.getAttribute('data-v');
        var multi = opt.hasAttribute('data-multi');
        var stepEl = opt.closest('[data-quiz-step]');
        if (multi) {
          answers[key] = answers[key] || [];
          var i = answers[key].indexOf(val);
          if (i > -1) { answers[key].splice(i, 1); opt.classList.remove('is-on'); }
          else { answers[key].push(val); opt.classList.add('is-on'); }
        } else {
          answers[key] = val;
          stepEl.querySelectorAll('.kasha-quiz__opt').forEach(function (o) { o.classList.remove('is-on'); });
          opt.classList.add('is-on');
        }
        refreshNext(stepEl);
      });
    });

    quiz.querySelectorAll('[data-quiz-next]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var stepEl = btn.closest('[data-quiz-step]');
        if (stepEl && stepEl.hasAttribute('data-quiz-step')) {
          if (btn.hasAttribute('data-last')) { idx = steps.length; show(gate); setProgress(steps.length); }
          else { idx++; show(steps[idx]); setProgress(idx); }
        }
      });
    });

    quiz.querySelectorAll('[data-quiz-back]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (idx > 0) { idx--; show(steps[idx]); setProgress(idx); }
      });
    });

    var gateForm = quiz.querySelector('[data-quiz-gate-form]');
    if (gateForm) {
      gateForm.addEventListener('submit', function (e) {
        e.preventDefault();
        try {
          fetch(gateForm.action, { method: 'POST', body: new FormData(gateForm) });
        } catch (err) { /* non-blocking */ }
        renderResult();
      });
    }

    function renderResult() {
      var goal = answers.goal || 'daily';
      var names = {
        sleep: 'Adaptogens & Sleep Aid', metab: 'Glucose & Metabolism Support',
        anti: 'Antioxidant Support', men: 'Sexual Health',
        energy: 'Energy Metabolism Support', daily: 'Bone & Mineral Support'
      };
      var name = names[goal] || names.daily;
      result.querySelector('[data-quiz-res-name]').textContent = name + '.';
      var link = result.querySelector('[data-quiz-res-link]');
      link.href = quiz.getAttribute('data-c-' + goal) || '#';
      link.textContent = 'Shop ' + name + ' →';
      setProgress(total);
      show(result);
    }

    quiz.querySelectorAll('[data-quiz-restart]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        idx = 0;
        answers = {};
        quiz.querySelectorAll('.kasha-quiz__opt').forEach(function (o) { o.classList.remove('is-on'); });
        quiz.querySelectorAll('[data-quiz-step] [data-quiz-next]').forEach(function (n) {
          if (!n.hasAttribute('data-optional')) n.disabled = true;
        });
        show(steps[0]);
        setProgress(0);
      });
    });

    setProgress(0);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  (function () {
    if (window.__kashaCartOptimistic) return;
    window.__kashaCartOptimistic = true;

    function money(cents) {
      var n = (cents / 100).toFixed(2);
      var p = n.split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return '$' + p.join('.');
    }
    function moneyWithCurrency(cents) {
      // Match {{ cart.total_price | money_with_currency }} output, e.g. "$52.94 CAD"
      var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'CAD';
      return money(cents) + ' ' + currency;
    }
    function findTotalCents() {
      // Sum all visible line totals from the cart-items table to predict the new subtotal.
      var rows = document.querySelectorAll('cart-items .cart-item');
      var sum = 0;
      rows.forEach(function (row) {
        var input = row.querySelector('.quantity__input');
        if (!input) return;
        var unit = parseInt(input.getAttribute('data-unit-price'), 10) || 0;
        var qty = parseInt(input.value, 10) || 0;
        sum += unit * qty;
      });
      return sum;
    }
    function fade(el) {
      if (!el) return;
      el.style.animation = 'none';
      void el.offsetWidth;
      el.style.animation = 'kashaCartFade 0.32s ease';
    }

    function repaintTotalsAndBanner() {
      var totalCents = findTotalCents();
      document.querySelectorAll('#main-cart-footer .totals__total-value').forEach(function (el) {
        el.textContent = moneyWithCurrency(totalCents);
        fade(el);
      });
      /* Cart-banner ship-bar repaint removed 2026-08-10 with the progress bar itself. */
    }

    // Optimistic row removal. Trash icon fires Dawn's updateQuantity(line, 0).
    // Capture-phase so we animate + recompute totals before Dawn's fetch starts.
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('cart-remove-button');
      if (!btn) return;
      var row = btn.closest('.cart-item');
      if (!row || row.classList.contains('kasha-removing')) return;
      row.classList.add('kasha-removing');
      // Zero out the input so findTotalCents excludes this line.
      var input = row.querySelector('.quantity__input');
      if (input) input.value = '0';
      repaintTotalsAndBanner();
    }, true);

    // Listen for qty changes on the cart page. The change fires immediately after
    // Dawn's stepUp/stepDown, well before the debounced /cart/change.js request,
    // so updating the DOM here makes price changes feel instant.
    document.addEventListener('change', function (e) {
      var input = e.target;
      if (!input || !input.classList || !input.classList.contains('quantity__input')) return;
      if (!input.closest('cart-items')) return;
      var row = input.closest('.cart-item');
      if (!row) return;
      var unit = parseInt(input.getAttribute('data-unit-price'), 10);
      if (!unit) return;
      var newQty = Math.max(0, parseInt(input.value, 10) || 0);
      var newLine = unit * newQty;

      // Line totals (desktop + mobile each render their own .price--end inside .cart-item__price-wrapper)
      row.querySelectorAll('.cart-item__price-wrapper .price--end').forEach(function (el) {
        el.textContent = money(newLine);
        fade(el);
      });

      repaintTotalsAndBanner();
    }, true);

    // Prefetch /checkout while the customer reviews the cart; makes the
    // Checkout click feel instant.
    (function prefetchCheckout() {
      if (!document.querySelector('cart-items')) return;
      var fired = false;
      function warm() {
        if (fired) return; fired = true;
        var l = document.createElement('link');
        l.rel = 'prefetch'; l.href = '/checkout'; l.as = 'document';
        document.head.appendChild(l);
      }
      if (document.readyState === 'complete') setTimeout(warm, 800);
      else window.addEventListener('load', function () { setTimeout(warm, 800); });
    })();
  })();

  } catch(e) { console.error(e); }
})();
})();
